import { Card, Flex, Progress } from "antd"
import React, { useMemo } from "react"
import { Title, Text } from "ui/Typography"
import { useTranslation } from "react-i18next"
import styles from "./index.module.css"
import { spacings } from "themes/variables"
import { useSelector } from "react-redux"
import ReactStars from "react-rating-stars-component"

const getFormattedProgressText = (percent) => {
  return <Text>{percent}%</Text>
}

const RatingSummaryCard = () => {
  const { data } = useSelector((store) => store.guideProfile?.reviews)
  const { average_rating, distribution, total } = data || {}
  const { t } = useTranslation()

  const starData = useMemo(() => {
    return {
      count: 5,
      size: 24,
      value: Number(average_rating) || 0,
      isHalf: true,
      edit: false,
      activeColor: "var(--color-primary)"
    }
  }, [average_rating])

  return (
    <Card>
      <Flex vertical gap={spacings.L}>
        <Flex vertical className={`${styles.ratingCard} py-s`} align="center">
          <Flex vertical align="center">
            <Title level={4}>{parseFloat(average_rating).toFixed(1)}</Title>
            <Flex align="center" gap={spacings.XXS}>
              <ReactStars key={`stars-${starData.value}`} {...starData} />
            </Flex>
            <Text size="lg">
              {total || 0} {t("reviews.title", "Review(s)")}
            </Text>
          </Flex>
        </Flex>
        <Flex gap={spacings.XS} vertical>
          {distribution &&
            Object.entries(distribution)
              ?.reverse()
              ?.map(([stars, percent]) => (
                <Flex key={stars} align="center" gap={spacings.S}>
                  <Text size="md" fw={600}>
                    {stars}
                  </Text>
                  <Progress percent={percent} format={(percent) => getFormattedProgressText(percent)} />
                </Flex>
              ))}
        </Flex>
      </Flex>
    </Card>
  )
}

export default RatingSummaryCard
